import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { LandingPageCMSService } from '../landing-page-cms.service';
import { LandingPageCMS } from '../landing-page-cms';
import { LandingPageCMSComponent } from '../landing-page-cms/landing-page-cms.component';

@Component({
    selector: 'app-landing-page-cms-list',
    templateUrl: './landing-page-cms-list.component.html',
    styleUrls: ['./landing-page-cms-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class LandingPageCMSListComponent implements OnInit {
	locations: any[]=[];
	constructor(
		private landingPageCMSService: LandingPageCMSService,
		private alertService: AlertService,
		private constantService: ConstantService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = landingPageCMSService.statuses;
		this.locations = this.constantService.locations;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	landingPageCMSs: any;
	landingPageCMS: LandingPageCMS;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'landingPageCMSId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'displayUrl', header: 'Display Url', width: 'auto' },
		{ field: 'searchLocationId', header: 'Search LocationId', width: 'auto' },
		{ field: 'searchName', header: 'Search Name', width: 'auto' },
		{ field: 'searchCheckInDate', header: 'Search CheckInDate', width: 'auto' },
		{ field: 'searchCheckOutDate', header: 'Search CheckOutDate', width: 'auto' },
		{ field: 'searchCheckInDateStart', header: 'Search CheckInDate Start', width: 'auto' },
		{ field: 'searchCheckOutDateEnd', header: 'Search CheckOutDate End', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.landingPageCMSId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-landingPageCMS-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.landingPageCMSService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.landingPageCMSs = res.data.landingPageCMSs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.landingPageCMSs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(landingPageCMS: LandingPageCMS) {
		try {
			this.formLoading = true;
			this.landingPageCMSService.update(landingPageCMS)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.landingPageCMSs.map((landingPageCMS, i) => {
							if (landingPageCMS.landingPageCMSId === res.data.landingPageCMS.landingPageCMSId) {
								this.landingPageCMSs[i] = res.data.landingPageCMS;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(landingPageCMS: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(landingPageCMS));

			this.formLoading = true;
			this.landingPageCMSService.delete(landingPageCMS.landingPageCMSId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.landingPageCMSs.splice(this.landingPageCMSs.indexOf(landingPageCMS), 1);
						this.recordTotal = this.landingPageCMSs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'LandingPageCMS ' + landingPageCMS.landingPageCMSId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'LandingPageCMS ' + landingPageCMS.landingPageCMSId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "70vw";
			dialogConfig.width = "55vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add LandingPageCMS'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(LandingPageCMSComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addLandingPageCMSCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(landingPageCMS: LandingPageCMS) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "70vw";
			dialogConfig.width = "55vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			landingPageCMS: landingPageCMS,
			title: 'Edit LandingPageCMS'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(LandingPageCMSComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateLandingPageCMSCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteLandingPageCMSCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addLandingPageCMSCB(landingPageCMS: LandingPageCMS) {
		console.log('Adding LandingPageCMS: ' + JSON.stringify(landingPageCMS));
		// if we don't have a landingPageCMSs array yet...
		if (!this.landingPageCMSs) {
			this.landingPageCMSs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.landingPageCMSs.unshift(landingPageCMS);

		// no idea what this is but it is required to update the array
		this.landingPageCMSs = [...this.landingPageCMSs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LandingPageCMS ' + landingPageCMS.landingPageCMSId + ' Added', life: 3000 });
	}

	updateLandingPageCMSCB(landingPageCMS: LandingPageCMS) {
		console.log('Updating LandingPageCMS: ' + JSON.stringify(landingPageCMS));
		let itemIndex = this.landingPageCMSs.findIndex((item: any) => item.landingPageCMSId === landingPageCMS.landingPageCMSId);
		this.landingPageCMSs[itemIndex] = landingPageCMS;

		// no idea what this is but it is required to update the array
		this.landingPageCMSs = [...this.landingPageCMSs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LandingPageCMS ' + landingPageCMS.landingPageCMSId + ' Updated', life: 3000 });
	}

	deleteLandingPageCMSCB(landingPageCMS: LandingPageCMS) {
		console.log('Removing LandingPageCMS: ' + landingPageCMS);
		this.landingPageCMSs.splice(this.landingPageCMSs.indexOf(landingPageCMS), 1);
		this.recordTotal = this.landingPageCMSs.length;

		// no idea what this is but it is required to update the array
		this.landingPageCMSs = [...this.landingPageCMSs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'LandingPageCMS ' + landingPageCMS.landingPageCMSId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.landingPageCMSs ? this.first === (this.landingPageCMSs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.landingPageCMSs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(landingPageCMS: any) {
		if (landingPageCMS?.status) {
			const status = this.statuses.find((e: any) => e.value == landingPageCMS.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getSearchLocationName(landingPageCMS: any) {
		if (landingPageCMS?.searchLocationId) {
			const status = this.locations.find((e: any) => e.value == landingPageCMS.searchLocationId);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
